import React from "react";

function SystemAllocationViewComp() {
  return <div>SystemAllocationComp</div>;
}

export default SystemAllocationViewComp;
